import { render } from "./SvgAssets.vue?vue&type=template&id=782c9db4&scoped=true"
import script from "./SvgAssets.vue?vue&type=script&lang=js"
export * from "./SvgAssets.vue?vue&type=script&lang=js"

import "./SvgAssets.vue?vue&type=style&index=0&id=782c9db4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782c9db4"]])

export default __exports__